export default {
  namespaced: true,
  state: {
    requestFiles: [],
    currentUploadPath: null,
    bucketName: null,
    loading: false,
  },
  getters: {
    index: state => (state.requestFiles.length ? state.requestFiles.length - 1 : 0),
  },
  mutations: {
    SET_REQUEST_FILES(state, value) {
      state.requestFiles = value
    },
    SET_CURRENT_UPLOAD_PATH(state, value) {
      state.currentUploadPath = value
    },
    SET_BUCKET_NAME(state, value) {
      state.bucketName = value
    },
    SET_LOADING(state, value) {
      state.loading = value
    },
  },
}
